<template>
    <div>
        <b-modal
            id="startTaskModal"
            ref="startTaskModal"
            :lazy="true"
            @shown="shown"
            title-tag="h2"
            :title="data.label.text"
        >
            <!-- Modal Form -->

            <form class="form-horizontal pl-1">
                <b-alert show variant="warning" v-if="is_locked">
                    {{ locked.message }}
                </b-alert>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Patient:</label>
                    <div class="col-sm-9 col-form-label">
                        {{ patient ? patient.name : "" }}
                    </div>
                </div>
                <b-form-group
                    label="Date:"
                    class
                    :label-cols="2"
                    label-for="time"
                >
                    <vet-datetime
                        id="time"
                        :disabled="is_locked"
                        v-model="data.time"
                        v-validate="'required'"
                        :placeholder="{
                            date: 'Date (required)',
                            time: 'Time (required)'
                        }"
                        :inner-class="{
                            'border-danger': errors.has('data.time')
                        }"
                        container="#startTaskModal"
                        rules="required"
                        name="time"
                    ></vet-datetime>
                </b-form-group>
                <b-form-group
                    :label-for="`notes`"
                    :label-cols="2"
                    label="Notes:"
                    class="mb-0"
                >
                    <b-form-textarea
                        id="notes"
                        :disabled="is_locked"
                        v-model="data.note"
                        class="form-control"
                        placeholder="Notes (optional)"
                        rows="3"
                    ></b-form-textarea>
                </b-form-group>
            </form>

            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.startTaskModal.hide('cancel')"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button
                        v-if="
                            !loading &&
                            (!isTreatmentboardNew || params.isOpenFromSoap)
                        "
                        :disabled="is_locked"
                        @click="save"
                        class="float-left"
                        variant="primary"
                        >Complete</b-button
                    >
                    <b-button-group v-else-if="!loading && isTreatmentboardNew">
                        <b-dropdown
                            @click="save"
                            :disabled="is_locked"
                            left
                            split
                            variant="primary"
                            text="Complete"
                        >
                            <b-dropdown-item
                                v-if="
                                    _hasAccess(
                                        'schedule.treatmentboard.update'
                                    ) && activity.status === 3
                                "
                                @click="
                                    triggerTreatmentboardAction('reactivate')
                                "
                                >Reactivate</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="
                                    _hasAccess(
                                        'schedule.treatmentboard.update'
                                    ) && activity.status !== 3
                                "
                                @click="triggerTreatmentboardAction('edit')"
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="
                                    _hasAccess(
                                        'schedule.treatmentboard.create'
                                    ) && activity.status !== 3
                                "
                                @click="
                                    triggerTreatmentboardAction('duplicate')
                                "
                                >Duplicate</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="
                                    _hasAccess(
                                        'schedule.treatmentboard.delete'
                                    ) && activity.status === 0
                                "
                                @click="
                                    triggerTreatmentboardAction('deactivate')
                                "
                                >Deactivate</b-dropdown-item
                            >
                            <b-dropdown-item
                                v-if="
                                    _hasAccess(
                                        'schedule.treatmentboard.delete'
                                    ) && activity.status === 1
                                "
                                @click="triggerTreatmentboardAction('delete')"
                                >Delete</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="triggerTreatmentboardAction('history')"
                                >History</b-dropdown-item
                            >
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { some, find } from "lodash";
import { DateTime } from "luxon";
import vetDatetime from "@/module/commons/date-time-picker.vue";

export default {
    components: {
        vetDatetime
    },
    name: "StartTask",
    data() {
        return {
            loading: false,
            patient: null,
            activity: null,
            taskActivity: null,
            data: {
                patient: "",
                type: "",
                note: "",
                time: DateTime.local(),
                label: "Miscellaneous"
            },
            params: null,
            isTreatmentboardNew: false
        };
    },
    mounted() {},
    computed: {
        labelOptions() {
            return this.$store.state.reference["treatment-task-label"];
        },
        locked() {
            return this.activity
                ? this.$store.getters.locked(this.activity.id)
                : null;
        },
        is_locked() {
            return some(this.locked);
        }
    },
    methods: {
        open(params) {
            this.params = params;
            this.isTreatmentboardNew = params.isTreatmentboardNew;
            this.patient = params.patient;
            this.activity = params.activity;
            this.action = params.action;
            this.$refs.startTaskModal.show();
        },
        shown() {
            this.loading = true;
            this.getTaskActivity().then(() => {
                this.loading = false;
            });
        },
        async getTaskActivity() {
            const response = await this.$http.get(
                process.env.BARRACUDA + "schedule/activity/" + this.activity.id
            );
            if (response.data.response.resources) {
                this.taskActivity =
                    response.data.response.resources.other_tasks[0];

                this.data.label =
                    some(this.labelOptions) && this.taskActivity.label_id
                        ? find(this.labelOptions, {
                              value: this.taskActivity.label_id
                          })
                        : { text: "Miscellaneous", value: 1 };

                this.data.note = this.taskActivity.task;

                return this.taskActivity;
            }
            return [];
        },
        async save() {
            let self = this;
            let response = "";
            let valid = await self.$validator.validateAll();

            if (valid) {
                let data = {
                    treatment_board_id: self.activity.treatment_board_id,
                    patient_id: self.patient.id,
                    treatment_activity_type_id:
                        self.activity.treatment_activity_type_id,
                    due: self.activity.due,
                    due_type: self.activity.due_type,
                    note: self.activity.note,
                    complete_at: Math.round(self.data.time.toSeconds()),
                    complete_by: this.$root.currentActor.id,
                    status: 1,
                    otherTasks: [
                        {
                            label_id: self.taskActivity.label_id,
                            treatment_other_task_id: self.taskActivity.id,
                            task: self.data.note,
                            staff_id: [self.activity.create_by],
                            contact_id: [self.activity.create_by]
                        }
                    ]
                };

                this.loading = true;
                response = await this.$http.put(
                    process.env.BARRACUDA +
                        "schedule/activity/" +
                        self.activity.id,
                    data
                );

                if (response.status === 200) {
                    self.$root.$emit("treatment-board-refresh", {
                        params: { id: self.data.activityID },
                        treatment_board_id: self.activity.treatment_board_id
                    });

                    self.loading = false;
                    self.$refs.startTaskModal.hide();
                    self._message(response.message, "success");
                } else {
                    self.loading = false;
                    self._message("Error saving data", "danger");
                }
            }
        },
        triggerTreatmentboardAction(action) {
            this.$emit("activity-action", action, {
                treatment: this.params.treatment,
                activity: this.params.activity
            });
        }
    }
};
</script>
